<template>
    <div>
        <!-- <ion-item v-if="showNativeInput && platforms.includes('desktop')">
            <ion-label
                :position="placeholder === undefined ? 'floating' : 'stacked'"
                v-if="label !== ''"
                >{{ label }}</ion-label
            >
            <ion-input
                :value="value"
                @ionChange="$emit('input', $event.detail.value)"
                v-imask="{
                    mask: Date,
                    max: new Date(),
                }"
                :placeholder="placeholder"
            ></ion-input>
        </ion-item> -->
        <base-input
            :value="value"
            @input="$emit('input', $event)"
            :mask="{
                mask: Date,
                max: fullMaxDate,
            }"
            :placeholder="placeholder"
            v-if="showNativeInput && platforms.includes('desktop')"
            :infoText="infoText"
            :id="id"
            type="text"
            :label="label"
            inputmode="decimal"
            :disabled="disabled"
        ></base-input>
        <template v-else>
            <ion-item>
                <ion-label v-if="label !== ''" position="floating">{{
                    label
                }}</ion-label>
                <ion-datetime
                    :display-format="displayFormat"
                    :picker-format="pickerFormat"
                    :value="value"
                    @ionChange="$emit('input', $event.detail.value)"
                    :max="maxDate"
                    cancel-text="Abbrechen"
                    done-text="Fertig"
                    :min="minDate || weakMinDate"
                    :day-values="dayValues"
                    :disabled="disabled"
                ></ion-datetime>
            </ion-item>
            <input-error v-if="hasInputErrorField" :id="id"></input-error>
        </template>
    </div>
</template>

<script>
import InputError from "./InputError";
import BaseInput from "./BaseInput";

export default {
    components: {
        InputError,
        BaseInput,
    },
    data() {
        return {
            maxDate: undefined,
            platforms: Ionic.platforms,
            weakMinDate: undefined,
            fullMaxDate: undefined,
        };
    },
    mounted() {
        if (this.displayFormat !== "HH:mm") {
            const date = new Date();
            if (this.isFuture) {
                this.weakMinDate = date.toISOString();
                this.maxDate = date.getFullYear() + 1;
                this.fullMaxDate = new Date(
                    this.maxDate,
                    date.getMonth(),
                    date.getDate()
                );
            } else {
                this.maxDate = date.toISOString();
                this.fullMaxDate = date;
            }
        }
    },
    computed: {
        maxDateSubstring() {
            let result = undefined;
            if (this.maxDate) {
                result = this.maxDate.substring(0, 10);
            }
            return result;
        },
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        displayFormat: {
            type: String,
            required: false,
            default: "DD.MM.YYYY",
        },
        pickerFormat: {
            type: String,
            required: false,
            default: "DD.MM.YYYY",
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        hasInputErrorField: {
            type: Boolean,
            required: false,
            default: true,
        },
        showNativeInput: {
            type: Boolean,
            required: false,
            default: false,
        },
        placeholder: String,
        infoText: {
            type: String,
            required: false,
            default: "",
        },
        minDate: {
            type: String,
            required: false,
            default: undefined,
        },
        isFuture: {
            type: Boolean,
            required: false,
            default: false,
        },
        dayValues: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
ion-label {
    opacity: 0.33;
}
.label-floating.sc-ion-label-md-h,
.label-stacked.sc-ion-label-md-h {
    padding-top: 8px;
}
.item-has-value {
    ion-label {
        opacity: 1;
    }
}
</style>
